import { AggregationIcon, Box, Button, FormControlSizes, HStack, Icon, IconName, useCurrentWindow } from '@talos/kyoko';
import { useMarketSelectorContext } from './MarketSelectorContext';
import { CUSTOM_VALUE, MARKET_SELECTOR_POPOUT_WINDOW_NAME } from './tokens';

export function MarketSelectorPanelTitle() {
  const { isNarrow, presetsByID, preset, narrowModeConfig, disableAggregations } = useMarketSelectorContext();
  const currentWindow = useCurrentWindow();
  const isPopout = currentWindow.name === MARKET_SELECTOR_POPOUT_WINDOW_NAME;
  const showAggregationsNavigation = isNarrow && !isPopout && !disableAggregations;

  return showAggregationsNavigation ? (
    <HStack whiteSpace="nowrap" gap="spacing4">
      <Box ml="-spacing4" data-testid="market-selector-panel-title-aggregations-navigation-button">
        <Button
          onClick={e => {
            narrowModeConfig.setShowMarketSelectorBlotter(false);
            e.currentTarget.blur();
          }}
          startIcon={narrowModeConfig.showMarketSelectorBlotter ? IconName.ChevronLeft : IconName.Scale}
          size={FormControlSizes.Tiny}
          ghost={!narrowModeConfig.showMarketSelectorBlotter}
        >
          Aggregations
        </Button>
      </Box>
      {narrowModeConfig.showMarketSelectorBlotter ? (
        <HStack gap="spacing4" color="colorTextImportant" overflow="visible" flex="0 0 auto">
          <AggregationIcon />
          {presetsByID?.get(preset ?? CUSTOM_VALUE)?.label ?? 'Custom'}
        </HStack>
      ) : null}
    </HStack>
  ) : isPopout ? (
    <HStack gap="spacing4" lineHeight={1}>
      <Icon icon={IconName.Scale} />
      Market Selector
    </HStack>
  ) : (
    'Market Selector'
  );
}
